import { ref } from 'vue'
import axios from '@/utils/axios'
import useSnackbar, { SnackbarType } from '@/composables/snackbar'

export default function useUsers() {
  const RESOURCE = '/user'
  const { showSnackbar } = useSnackbar()
  const users = ref([])
  const isLoading = ref(false)

  const fetchUsers = async (size = 1000, sort = []) => {
    isLoading.value = true
    try {
      const params = new URLSearchParams()
      params.append('size', size)
      if (sort.length > 0) {
        sort.forEach(s => params.append('sort', s))
      }

      const response = await axios.post(
        `${RESOURCE}/searchUsers?${params.toString()}`,
        {},
        {
          headers: {
            'Content-Type': 'application/vnd.p72.app-1.0+json',
          },
        },
      )

      // Response has pagination structure with users in 'content' field
      users.value = response.data.content || []

      return response.data.content || []
    } catch (error) {
      const message = error.response?.data?.message ?? error.message
      const statusCode = error.response?.status ?? null
      showSnackbar(
        `Failed to fetch users:<br> ${statusCode ? `[${statusCode}]` : ''} ${message}`,
        SnackbarType.ERROR,
      )
      throw error
    } finally {
      isLoading.value = false
    }
  }

  const updateUser = async user => {
    isLoading.value = true
    try {
      const payload = { ...user }
      delete payload.contentPacksCount

      await axios.put(RESOURCE, payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      showSnackbar('User updated successfully', SnackbarType.SUCCESS)
    } catch (error) {
      const message = error.response?.data?.message ?? error.message
      const statusCode = error.response?.status ?? null
      showSnackbar(
        `Failed to update user:<br> ${statusCode ? `[${statusCode}]` : ''} ${message}`,
        SnackbarType.ERROR,
      )
      throw error
    } finally {
      isLoading.value = false
    }
  }

  const resetState = () => {
    users.value = []
    isLoading.value = false
  }

  return {
    users,
    isLoading,
    fetchUsers,
    updateUser,
    resetState,
  }
}
